import PayrollGroupPaymentsPage from './PayrollGroupPaymentsPage';
export default PayrollGroupPaymentsPage;